export default {
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        modalWidth: {
            type: String,
            required: false,
            default: '56%'
        }
    },
    data() {
        return {
            showModal: false
        }
    },
    watch: {
        visible(newVal) {
            this.showModal = newVal;
        },
        showModal(show) {
            if (!show) {
                this.closeModal();
            }
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
        }
    },
    mounted() {
        this.showModal = this.visible;
    }
}